// extracted by mini-css-extract-plugin
export default {"backImage":"login_backImage__xNilK"};